import * as React from 'react';
import { BaseCommonPage } from '../layout/BaseCommonPage';
import { BasePageContent } from './Base';

const NoAccess: React.FC = () => {
  return (
    <BaseCommonPage>
      <BasePageContent>
        <h1>Du har ikke tilgang</h1>
        <p>Du må være innlogget for å kunne vise denne siden..</p>
      </BasePageContent>
    </BaseCommonPage>
  );
};

export default NoAccess;
